import React from 'react';
import { Heart } from 'lucide-react';
import { BRAND } from '../data/brand';

// 与 AuthPage 主视图同款的品牌标:心形徽标 + 字标,登录/注册全屏页复用。
const SIZES = {
  lg: { badge: 'w-11 h-11 rounded-[14px]', icon: 'w-6 h-6', text: 'text-[34px] leading-none' },
  sm: { badge: 'w-8 h-8 rounded-[10px]', icon: 'w-[18px] h-[18px]', text: 'text-[22px] leading-none' }
};

const BrandLogo = ({ size = 'lg', className = '' }) => {
  const s = SIZES[size] || SIZES.lg;
  return (
    <div className={`flex items-center justify-center gap-2.5 ${className}`}>
      <span className={`${s.badge} bg-brand-500 flex items-center justify-center flex-shrink-0`}>
        <Heart className={`${s.icon} text-white fill-white`} strokeWidth={2.2} />
      </span>
      <span className={`${s.text} font-extrabold text-brand-500 tracking-tight`}>
        {BRAND.name}
      </span>
    </div>
  );
};

export default BrandLogo;
